export const defaultState = () => ({
  titles: {},
  values: {}
});

const state = defaultState();

export default state;
